import type { components } from "#/schema";

export function isLeerjaarValid(
  leerjaar: components["schemas"]["BeweegactiviteitDetailModel"] | undefined,
): "valid" | "empty" | "invalid" {
  if (!leerjaar) return "empty";

  const beweegdoelen = leerjaar.beweegdoelen ?? [];

  // Meerkeuze follows the doelen rules; only VrijBeweegdoel takes the schalen path.
  if (leerjaar.type !== "VrijBeweegdoel") {
    const hasAtleastOneBeweegdoelFilled = beweegdoelen.some(
      (beweegdoel) => beweegdoel.description && beweegdoel.description.trim() !== "",
    );

    if (!leerjaar.name && !hasAtleastOneBeweegdoelFilled) {
      return "empty";
    }

    // not valid if name is not filled and has less than 3 beweegdoelen
    if (!leerjaar.name || beweegdoelen.length < 3) {
      return "invalid";
    }

    // not valid if none of the beweegdoelen are filled
    if (beweegdoelen.some((beweegdoel) => !beweegdoel.description)) {
      return "invalid";
    }

    return "valid";
  } else {
    if (!leerjaar.name) return "invalid";

    // is vrij beweegdoel case
    // check if vrijBeweegdoel has a postfix and if beoordelingsschalen has at least 3 items
    if (!leerjaar.vrijBeweegdoel?.postfix) {
      return "invalid";
    }

    if (leerjaar.vrijBeweegdoel?.beoordelingsschalen?.length < 3) {
      return "invalid";
    }

    // check if the ranges are closed, so the upperBound is equals to the next range lowerBound
    for (let i = 0; i < leerjaar.vrijBeweegdoel?.beoordelingsschalen?.length - 1; i++) {
      const lowerBound = leerjaar.vrijBeweegdoel?.beoordelingsschalen?.[i]?.lowerBound ?? 0;
      const upperBound = leerjaar.vrijBeweegdoel?.beoordelingsschalen?.[i]?.upperBound ?? 0;
      const nextLowerBound = leerjaar.vrijBeweegdoel?.beoordelingsschalen?.[i + 1]?.lowerBound ?? 0;

      if (upperBound !== nextLowerBound) {
        return "invalid";
      }

      // and check that the lowerBound is always lower than the upperBound of the
      if (lowerBound >= upperBound) {
        return "invalid";
      }
    }

    return "valid";
  }
}
